import React from "react";

const GoogleDocsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.359 20.4545H28.6317V23.6363H11.359V20.4545Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.359 25.9091H24.0863V29.0909H11.359V25.9091Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5408 10L30.0249 11.0364L34.5408 10L24.5408 0L23.1613 4.74091L24.5408 10Z",
  fill: "#1967D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.359 15H28.6317V18.1818H11.359V15Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5409 10V0H8.17722C6.67041 0 5.44995 1.22045 5.44995 2.72727V37.2727C5.44995 38.7795 6.67041 40 8.17722 40H31.8136C33.3204 40 34.5409 38.7795 34.5409 37.2727V10H24.5409ZM23.6318 28.6364H11.8136V26.3636H23.6318V28.6364ZM28.1772 23.1818H11.8136V20.9091H28.1772V23.1818ZM28.1772 17.7273H11.8136V15.4545H28.1772V17.7273Z",
  fill: "#4285F4"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleDocsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;